export default __webpack_public_path__ + "3a8256896b610a255d7f44e84f4e27c4.png";